import Directions from "@/components/Directions";
import { LatLngExpression } from "leaflet";
import {useEffect, useState} from "react";
import { MapContainer, Marker, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { motion } from "framer-motion";
import { tabVariantsAnimation } from "@/theme/theme";
import {CATEGORY_COLORS} from "@/utils/constants";


type MapType = {
    coords: {
        lng: number;
        lat: number;
    };
};

const CustomSVGMarker = (color, isHovered) => {
    return `
    <svg width="45" height="45" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="${isHovered ? "animate-bounce" : ""}">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M21.0999 9.25228C19.1399 0.59228 6.30992 0.58228 4.33992 9.24228C3.18992 14.3223 6.34992 18.6323 9.10992 21.2923C11.1299 23.2323 14.3099 23.2323 16.3199 21.2923C19.0899 18.6323 22.2499 14.3323 21.0999 9.25228ZM15.8403 11.0623C15.8403 12.7854 14.4435 14.1823 12.7203 14.1823C10.9972 14.1823 9.60034 12.7854 9.60034 11.0623C9.60034 9.33918 10.9972 7.94231 12.7203 7.94231C14.4435 7.94231 15.8403 9.33918 15.8403 11.0623Z" fill="${color}"/>
    </svg>
  `;
};

// Function to create custom icon
export const createCustomIcon = (color, isHovered) => {
    return L.divIcon({
        html: CustomSVGMarker(color, isHovered),
        className: "custom-svg-marker",
        iconSize: [45, 45],
    });
};

const Map: React.FC<MapType> = ({ coords, color}) => {
    const position: LatLngExpression = [Number(coords.lat), Number(coords.lng)];

    return (
        <motion.div
            variants={tabVariantsAnimation}
            animate='animate'
            initial='initial'
            className="space-y-10"
        >
            <Directions

                destinationLat={coords.lat}
                destinationLng={coords.lng}
            />
            <MapContainer
                center={position}
                zoom={18}
                className="w-full h-[400px] lg:h-[870px] z-10"
                maxZoom={18}
                minZoom={5}
            >
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                <Marker position={position} icon={createCustomIcon(
                    color,
                    false,
                )}/>
            </MapContainer>
        </motion.div>
    );
};

export default Map;
